import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive-bs4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import $ from "jquery";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import { useEffect, useRef } from "react";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import moment from 'moment';
import { ImprimirMovimiento } from "./ImprimirMovimiento";
import ReporteMovimiento  from "./ReporteMovimiento";
import { createRoot } from "react-dom/client";
import { pdf } from '@react-pdf/renderer';
import Swal from 'sweetalert2';
import { mostraAlertaError } from "../../../../componentes/alerts/sweetAlert";

const TablaIngresoEgreso = ({ datos }) => {

    const handleImprimirMovimiento = (movimiento) => {
        ImprimirMovimiento(movimiento);
    };

    const handleImprimirReporteMovimiento = async (movimiento) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        if (movimiento) {
            try {
                const blob = await pdf(<ReporteMovimiento movimiento={movimiento} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `ReporteMovimiento_${movimiento.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };


    const tableRef = useRef();
    useEffect(() => {
        // Destruir la instancia anterior de DataTables si existe
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        // Inicialización y configuración de DataTables
        $(tableRef.current).DataTable({
            data: datos,
            columns: [
                {
                    title: "ID",
                    data: "id"
                },
                {
                    title: "Fecha Transacción",
                    data: "fecha",
                    render: (fecha) => {
                        const f = moment(fecha);
                        return f.isValid() ? f.format("DD/MM/YYYY") : "N/A";
                    }
                },
                {
                    title: "Tipo",
                    data: "tipo",
                    render: (tipo) => {
                        // Aplicar color condicional (Verde para Ingresos, Rojo para Egresos)
                        const clase = tipo === 'Ingresos' ? 'bg-success' : 'bg-danger';
                        return `<span class="badge ${clase} p-2">${tipo}</span>`;
                    }
                },
                {
                    title: "Monto",
                    data: "monto",
                    render: (monto, type, row) => {
                        const valor = parseFloat(monto || 0);
                        const tipo = row.tipo;

                        // Aplicar color en base al tipo (verde para Ingreso, rojo para Egreso)
                        const color = tipo === 'Ingresos' ? 'text-success' : 'text-danger';

                        // Formatear y añadir signo
                        const signo = tipo === 'Ingresos' ? '+' : '-';

                        return `<span class="${color} fw-bold">${signo} ${formatoMoneda(valor)}</span>`;
                    }
                },
                {
                    title: "Notas",
                    data: "notas",
                },
                {
                    title: "Acciones",
                    data: null,
                    orderable: false,
                    searchable: false,
                    className: "dt-center all",
                    exportable: false, // Mantenemos esta para CSV/Excel/PDF
                    createdCell: (td, cellData, rowData, row, col) => {
                        const root = createRoot(td);
                        root.render(
                            <>
                                <button
                                    className="btn btn-outline-info"
                                    onClick={() => handleImprimirMovimiento(rowData)}
                                    title="Imprimir Movimiento"
                                >
                                    <i className="fas fa-print"></i>
                                </button>
                                <button
                                    className="btn btn-outline-success mx-2"
                                    onClick={() => handleImprimirReporteMovimiento(rowData)}
                                    title="Imprimir Reporte Movimiento"
                                >
                                    <i className="fas fa-chart-bar"></i>
                                </button>
                            </>
                        );
                    },
                },
            ],
            paging: true,
            lengthChange: true,
            pageLength: 10,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: true,
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            dom:
                "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            responsive: true,
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                infoPostFix: "",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                zeroRecords: "Sin resultados encontrados",
                search: "Buscar",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            order: [[0, 'desc']], // Ordenar por ID descendente por defecto
            destroy: true,
        });
    }, [datos]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                id="tabla-ingresos-egresos" // ID único para la tabla
                className="table table-bordered table-hover"
            ></table>
        </div>
    );
};

export default TablaIngresoEgreso;